import React, { useState } from 'react'
import { MenuItem, Typography, Select, FormControl, Chip } from '@mui/material'
import Avatar from '@mui/material/Avatar'
import { IoIosCloseCircleOutline } from 'react-icons/io'

const MultiSelectWithChips = () => {
    const [ selectedOptions, setSelectedOptions ] = useState([])

    const handleChange = (event) => {
        setSelectedOptions(event.target.value)
    }

    const handleDelete = (optionToDelete) => () => {
        setSelectedOptions((prevOptions) =>
            prevOptions.filter((option) => option !== optionToDelete)
        )
    }

    return (
        <FormControl className='w-full'>
            <Select
                multiple
                value={selectedOptions}
                onChange={handleChange}
                renderValue={(selected) => (
                    <div style={{ display: 'flex', width: '100%', maxWidth: 'auto', overflowX: 'auto' }} >
                        {selected.map((option, ind) => (
                            <div key={ind} className='rounded-lg border border-gray-300 m-1 h-14 w-56 flex items-center p-4 ' style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between' }}>
                                <Typography class='flex' >
                                    <Avatar>H</Avatar>
                                    <Typography class='flex flex-col justify-center pl-2'>
                                        <Typography fontSize={10}>
                                            Kavya
                                        </Typography>
                                        <Chip label="danger" style={{ color: 'hsl(var(--success))', height: '15px' }} variant="outlined" />
                                    </Typography>
                                </Typography>
                                <IoIosCloseCircleOutline onClick={() => handleDelete(option)} style={{ color: '#BA1717', fontSize: '25px' }} />
                            </div>
                        ))}
                    </div>
                )}
            >
                <MenuItem value="Option 1">Option 1</MenuItem>
                <MenuItem value="Option 2">Option 2</MenuItem>
                <MenuItem value="Option 3">Option 3</MenuItem>
                <MenuItem value="Option 4">Option 4</MenuItem>
                <MenuItem value="Option 5">Option 5</MenuItem>
                <MenuItem value="Option 6">Option 6</MenuItem>
                <MenuItem value="Option 7">Option 7</MenuItem>
                <MenuItem value="Option 8">Option 8</MenuItem>
                <MenuItem value="Option 9">Option 9</MenuItem>
                <MenuItem value="Option 10">Option 10</MenuItem>
                <MenuItem value="Option 11">Option 11</MenuItem>
                <MenuItem value="Option 12">Option 12</MenuItem>
            </Select>
        </FormControl>
    )
}

export default MultiSelectWithChips
